import {
  addDoc,
  collection,
  doc,
  onSnapshot,
  serverTimestamp,
  updateDoc,
  writeBatch,
} from 'firebase/firestore';
import { firestore } from '../firebase';
import { subscribeSharedFirestore } from './sharedFirestoreSubscription';
import { ASSIGNMENT_TYPES } from '../utils/assignmentUtils';

const assignmentTypeCollection = collection(firestore, 'assignmentTypes');

const MATTER_REQUIRED_DEFAULTS = new Set([
  'GST Notice',
  'Income Tax Notice',
  'GST Appeal',
  'Income Tax Appeal',
  'GST Refund',
]);

export function subscribeAssignmentTypes(onData, onError) {
  const handleRows = (rawRows) => {
    const rows = [...rawRows];
    rows.sort((a, b) => {
      const orderA = Number.isFinite(Number(a.sortOrder)) ? Number(a.sortOrder) : 9999;
      const orderB = Number.isFinite(Number(b.sortOrder)) ? Number(b.sortOrder) : 9999;
      if (orderA !== orderB) return orderA - orderB;
      return String(a.name || '').localeCompare(String(b.name || ''));
    });
    onData(rows);
  };

  return subscribeSharedFirestore({
    key: 'assignmentTypes:all',
    onData: handleRows,
    onError,
    start: (emit, emitError) => onSnapshot(
      assignmentTypeCollection,
      (snapshot) => emit(snapshot.docs.map((item) => ({ id: item.id, ...item.data() }))),
      emitError
    ),
  });
}

export async function createAssignmentType(values, userData) {
  return addDoc(assignmentTypeCollection, {
    name: values.name.trim(),
    requiresMatter: Boolean(values.requiresMatter),
    isActive: values.isActive !== false,
    sortOrder: Number(values.sortOrder) || 0,
    createdById: userData?.id || '',
    createdByName: userData?.name || userData?.email || '',
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
}

export async function updateAssignmentType(id, values) {
  return updateDoc(doc(firestore, 'assignmentTypes', id), {
    name: values.name.trim(),
    requiresMatter: Boolean(values.requiresMatter),
    isActive: values.isActive !== false,
    sortOrder: Number(values.sortOrder) || 0,
    updatedAt: serverTimestamp(),
  });
}

export async function toggleAssignmentTypeStatus(id, isActive) {
  return updateDoc(doc(firestore, 'assignmentTypes', id), {
    isActive,
    updatedAt: serverTimestamp(),
  });
}

export async function initializeDefaultAssignmentTypes(existingTypes, userData) {
  const existingNames = new Set(
    existingTypes.map((item) => String(item.name || '').trim().toLowerCase()).filter(Boolean)
  );
  const missing = ASSIGNMENT_TYPES.filter(
    (name) => !existingNames.has(name.trim().toLowerCase())
  );

  if (!missing.length) return 0;

  const batch = writeBatch(firestore);
  missing.forEach((name, index) => {
    const ref = doc(assignmentTypeCollection);
    batch.set(ref, {
      name,
      requiresMatter: MATTER_REQUIRED_DEFAULTS.has(name),
      isActive: true,
      sortOrder: existingTypes.length + index + 1,
      createdById: userData?.id || '',
      createdByName: userData?.name || userData?.email || '',
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    });
  });
  await batch.commit();
  return missing.length;
}
